export const notificationKey = {
    root: ['notification'] as const,
    byUser: (userId: string) =>
        [...notificationKey.root, 'list', 'byUser', userId] as const,
    paged: (userId: string, page: { skip: number; take: number }) =>
        [...notificationKey.byUser(userId), 'paged', page] as const,
    infinite: (userId: string, take: number) =>
        [...notificationKey.byUser(userId), 'infinite', { take }] as const,
};
